import './styles/App.scss';
import ChatContainer from './components/ChatContainer';

function App() {
  return <ChatContainer />;
}

export default App;
